import 'react-datepicker/dist/react-datepicker.css';

import { useCallback, useEffect } from 'react';
import ReactDatePicker from 'react-datepicker';

import { ensurePortalNode, formatWeekDay, type IDatePicker } from './DatePicker.helpers';
import { DatePickerTrigger } from './DatePickerTrigger';

const DatePicker = ({
	label,
	id,
	value,
	onChange,
	errorMessage,
	minDate,
	maxDate,
	placeholder,
	required,
	disabled,
	portalId,
	calendarIconVariant = 'default',
}: IDatePicker) => {
	const handleChange = useCallback((date: Date | null) => onChange(date), [onChange]);

	useEffect(() => {
		if (portalId) ensurePortalNode(portalId);
	}, [portalId]);

	const labelDropdowns = useCallback(() => {
		document.querySelector('.react-datepicker__month-select')?.setAttribute('aria-label', 'Month');
		document.querySelector('.react-datepicker__year-select')?.setAttribute('aria-label', 'Year');
	}, []);

	return (
		<ReactDatePicker
			id={id}
			selected={value}
			onChange={handleChange}
			minDate={minDate}
			maxDate={maxDate}
			dateFormat='dd/MM/yyyy'
			showMonthDropdown
			showYearDropdown
			dropdownMode='select'
			showPopperArrow={false}
			disabled={disabled}
			required={required}
			portalId={portalId}
			onCalendarOpen={labelDropdowns}
			formatWeekDay={formatWeekDay}
			wrapperClassName='bt_datePicker'
			popperClassName='bt_datePicker_popper'
			calendarClassName='bt_datePicker_calendar'
			customInput={
				<DatePickerTrigger
					label={label}
					id={id}
					errorMessage={errorMessage}
					placeholder={placeholder}
					disabled={disabled}
					calendarIconVariant={calendarIconVariant}
				/>
			}
		/>
	);
};

export default DatePicker;
